angular.module('zc.projects').directive('zcCurrencyFormatter', zcCurrencyFormatter);

zcCurrencyFormatter.$inject = ['Project', 'currencies'];
function zcCurrencyFormatter(Project, currencies) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, elem, attrs, ngModel) {
      scope.currentProject = Project.currentProject;
      const currency = scope.currentProject
        ? currencies[Project.currentProject.currency]
        : null;
      const currencyMultiplier = currency
        ? 10 ** currency.fractionSize
        : 1;
      const formatter = value => value / currencyMultiplier;
      const parser = value => currencyMultiplier * value;
      ngModel.$setValidity('currency', currency != null);
      ngModel.$parsers.push(parser);
      ngModel.$formatters.push(formatter);
    }
  };
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/directives/projects/currency_formatter.directive.js